import { useState, useEffect } from "react";
import { FaCalendarAlt, FaCheck } from "react-icons/fa";
//import { obtenerNotificaciones } from "../../mockdata/Notificaciones.js";
import "./Notificaciones.css";
import Loader from "../../components/Loader/Loader.jsx";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {obtenerNotificacionesDeBD, marcarComoLeidaEnBD} from "../../service/notificacionService.js"
import { useAuth } from "../../context/authContext.jsx";



const Notificaciones = () => {
  const [notificaciones, setNotificaciones] = useState([]);
  const [filtroActivo, setFiltroActivo] = useState("ver_todas");
  const [cargando, setCargando] = useState(true);
  const [paginaActual, setPaginaActual] = useState(1);
  const notificacionesPorPagina = 5;

  const { usuario } = useAuth();

  const navigate = useNavigate();
//  const usuarioId = "6a480c72d6dad49a211eb341"; 
  const usuarioId = usuario?.pacienteId || usuario?.medicoId || usuario?._id;

  useEffect(() => {
    const cargarDatos = async () => {
      setCargando(true);
      try {
        const datos = await obtenerNotificacionesDeBD(usuarioId);
      console.log("Usuario:", usuario);
      console.log("Usuario ID:", usuarioId);
      console.log(datos);
        setNotificaciones(datos);
      } catch (error) {
        console.error("Error cargando notificaciones:", error);
        toast.error("Ocurrió un error al cargar tus notificaciones.", {
          toastId: "error-carga" // necesito asignarle un id para evitar que se muestre dos veces
        }); 
      } finally {
        setCargando(false);
      }
    };

    cargarDatos();
  }, [usuarioId]);

  const marcarComoLeida = async (id) => {
    try {

      await marcarComoLeidaEnBD(usuarioId, id); 

      setNotificaciones(prevNotificaciones => 
        prevNotificaciones.map(notif => 
          notif.id === id 
            ? { ...notif, leida: true, fechaHoraLeida: new Date() } 
            : notif
        )
      );
    toast.success("Notificación marcada como leída.");
      } catch (error) {
      toast.error("No se pudo marcar como leída.");
    }
  };

  const marcarTodasComoLeidas = async () => {
    const notifSinLeer = notificaciones.filter(notif => !notif.leida);

    if (notifSinLeer.length > 0) {
      try {
        const promesas = notifSinLeer.map(notif => marcarComoLeidaEnBD(usuarioId, notif.id));
        await Promise.all(promesas);

        setNotificaciones(prevNotificaciones => 
          prevNotificaciones.map(notif => 
            !notif.leida 
              ? { ...notif, leida: true, fechaHoraLeida: new Date() } 
              : notif
          )
        );
        toast.success("Todas las notificaciones fueron marcadas como leídas.");
      } catch (error) {
        toast.error("Hubo un error al marcar algunas notificaciones.");
      }
    } else {
      toast.info("No tienes notificaciones pendientes de lectura.");
    }
  };

  const notificacionesMostradas = notificaciones.filter(notif => {
    if (filtroActivo === "no_leidas") return !notif.leida;
    return true;
  });
  const indiceUltimaNotificacion = paginaActual * notificacionesPorPagina;
  const indicePrimeraNotificacion = indiceUltimaNotificacion - notificacionesPorPagina;

  const notificacionesPaginadas = notificacionesMostradas.slice(
    indicePrimeraNotificacion,
    indiceUltimaNotificacion
  );

  const cantidadPaginas = Math.ceil(
    notificacionesMostradas.length / notificacionesPorPagina
  );

  let contenidoPrincipal;

  if (cargando) {
    contenidoPrincipal = (<div className="notificaciones-loader-wrapper">
        <Loader />
      </div>);
  } else if (notificacionesMostradas.length === 0) {
    contenidoPrincipal = (
      <div className="notificaciones-vacias">
        No hay notificaciones para mostrar aquí.
      </div>
    );
  } else {
    contenidoPrincipal = notificacionesPaginadas.map((notif) => (
      <div key={notif.id} className={`notificacion-item ${notif.leida ? "read" : "unread"}`}>
        <div className="notificacion-icon-wrapper">
          {!notif.leida && <span className="blue-dot"></span>}
          <div className="icon-circle">
            {notif.leida && notif.mensaje.includes("perfil") ? (
              <FaCheck className="icon-check" />
            ) : (
              <FaCalendarAlt className="icon-default" />
            )}
          </div>
        </div>

        <div className="notificacion-content">
          <p className="notificacion-text">{notif.mensaje}</p> 
          <span className="notificacion-time">
            {new Date(notif.fechaHoraCreacion).toLocaleString("es-AR", { 
              hour: "2-digit", 
              minute: "2-digit", 
              day: "2-digit", 
              month: "short" 
            })}
          </span>
        </div>
{/* 
        <div className="notificacion-actions">
          {notif.mensaje.toLowerCase().includes("turno") && notif.turnoId && (
            <button 
              className="btn-view-turno" 
              onClick={() => navigate('/turnos?turnoId=${notif.turnoId}')}
            >
              Ver turno
            </button>
       
          )}
        </div>
*/}   
        {!notif.leida && (
          <button className="btn-mark-read" onClick={() => marcarComoLeida(notif.id)}>
            Marcar como leída
          </button>
        )}
      </div>
    ));
  }

  return (
    <div className="notificaciones-page">
      <div className="notificaciones-header">
        <h2>Tus Notificaciones</h2>
        <button className="btn-mark-all" onClick={marcarTodasComoLeidas} disabled={cargando}>
          Marcar todas como leídas
        </button>
      </div>

      <div className="notificaciones-container">
        <aside className="notificaciones-sidebar">
          <ul className="sidebar-menu">
            <li 
             className={filtroActivo === "ver_todas" ? "active" : ""} 
             onClick={() => {
               setFiltroActivo("ver_todas");
               setPaginaActual(1);
             }}
            >
              Ver Todas
            </li>
            <li 
             className={filtroActivo === "no_leidas" ? "active" : ""} 
             onClick={() => {
               setFiltroActivo("no_leidas");
               setPaginaActual(1);
             }}
            >
              No leídas
            </li>
          </ul>
        </aside>

        <main className="notificaciones-list">
          {contenidoPrincipal}

          {cantidadPaginas > 1 && (
            <div className="paginacion-notificaciones">
            
              <button
                disabled={paginaActual === 1}
                onClick={() => setPaginaActual(paginaActual - 1)}
              >
                Anterior
              </button>
          
              <span>
                Página {paginaActual} de {cantidadPaginas}
              </span>
          
              <button
                disabled={paginaActual === cantidadPaginas}
                onClick={() => setPaginaActual(paginaActual + 1)}
              >
                Siguiente
              </button>
          
            </div>
          )}

        </main>
      </div>
    </div>
  );
};

export default Notificaciones;